import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import axios from "axios";

const ContactUs = () => {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.mobile || !form.email || !form.message) {
      setResponseMsg("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      setResponseMsg("");

      const res = await axios.post(
        "https://api.happypayfintech.com/api/form/contact",
        form,
      );

      setResponseMsg(res.data.message);

      setForm({
        name: "",
        mobile: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error(err);
      setResponseMsg(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Header />

      <div className="contact-page">
        <Helmet>
          <title>Contact Us - Happy Pay Fintech</title>
        </Helmet>
      </div>

      <div className="body-overlay" />
      <main>
        <section className="contact-area contact-bg pt-200">
          <div className="container">
            <div className="row">
              {/* LEFT SIDE */}
              <div className="col-xl-5 col-lg-6">
                <div className="contact-content mb-30">
                  <h4 className="contact-title">Get in Touch</h4>
                  <p>
                    If you need help with your account or have questions about
                    AEPS, DMT, CMS, PAN Card & Utility Bill Payments, please
                    contact us.
                  </p>

                  {/* FIXED className */}
                  <div className="contact-info">
                    <a
                      href="mailto:happypayfintech@gmail.com"
                      className="contact-mail mb-15"
                    >
                      happypayfintech@gmail.com
                    </a>

                    <a href="tel:919741314333" className="contact-mail mb-20">
                      +91 9741314333
                    </a>

                    <a href="" className="contact-mail mb-20">
                      Registered Address: C/o Sri B.channayya, Ter Bazar Main
                      Road Kanakgiri, Near Partana Panchayat, Kanakgiri, Koppal,
                      Karnataka - 583283
                    </a>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDE FORM */}
              <div className="offset-xl-1 col-xl-6 col-lg-6">
                <div className="contact-form">
                  <h4 className="contact-form-title">Contact Us</h4>

                  <form onSubmit={handleSubmit}>
                    <div className="contact-form-input">
                      <input
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="contact-form-input">
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Your Mobile"
                        value={form.mobile}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="contact-form-input">
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        value={form.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="contact-form-input">
                      <input
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        value={form.subject}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="contact-form-input">
                      <textarea
                        name="message"
                        placeholder="Your Message"
                        value={form.message}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="contact-form-btn">
                      <button
                        type="submit"
                        className="tp-btn"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </form>

                  {/* RESPONSE MESSAGE */}
                  {responseMsg && (
                    <p style={{ marginTop: "10px" }}>{responseMsg}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* MAP SECTION (unchanged) */}
        <section className="map-area map-wrapper">
          <div className="container">
            <iframe
              title="Happy Pay Fintech Location"
              src="https://www.google.com/maps?q=Kanakagiri,Karnataka&output=embed"
              style={{ width: "100%", height: "400px", border: 0 }}
            />
          </div>
        </section>
      </main>

      <Footer />
    </React.Fragment>
  );
};

export default ContactUs;
